import {DrawerProps} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {Product} from "../types.ts";
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: Product,
        // Resolves true when the save landed. The drawer closes only then: a rejected
        // save keeps it open with the operator's values (§7).
        handleSubmit: (values: Product) => Promise<boolean>
    }) => {

    const title = record?.id ? I18n.get('Edit Product') : I18n.get('Add Product');

    const handleFormSubmit = async (values: Product) => {
        const saved = await handleSubmit(values);
        if (saved) {
            onClose();
        }
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    )
};
